(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editions-main"] && !Shopify.designMode) return;
  try {
    
    function fadeAnime(){
    // flipLeft
    $('.editions_list li').each(function(){ 
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll >= elemPos - windowHeight){
          $(this).addClass('flipLeft');
      }else{
          $(this).removeClass('flipLeft');
      }
    });
    }
    
    
    $(window).scroll(function (){
    fadeAnime();
    });
    
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
const relatedDiv = document.getElementById("related");
const parentDiv = relatedDiv.parentNode;
parentDiv.style.borderTop = "none";

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["special_offer"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-edition"] && !Shopify.designMode) return;
  try {
    
      
      
      lightbox.option({
        'wrapAround': true,
        'albumLabel': '%1 / total %2 '
      });
      
      
      function fadeAnime(){
      // flipLeft
      $('.editions_list li').each(function(){ 
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight){
            $(this).addClass('flipLeft');
        }else{
            $(this).removeClass('flipLeft');
        }
      });
      }
      
      
      $(window).scroll(function (){
      fadeAnime();
      });
      
      
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-020"] && !Shopify.designMode) return;
  try {
    
      
      
      lightbox.option({
        'wrapAround': true,
        'albumLabel': '%1 / total %2 '
      });
      
      
      function fadeAnime(){
      // flipLeft
      $('.editions_list li').each(function(){ 
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight){
            $(this).addClass('flipLeft');
        }else{
            $(this).removeClass('flipLeft');
        }
      });
      }
      
      
      $(window).scroll(function (){
      fadeAnime();
      });
      
      
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-021"] && !Shopify.designMode) return;
  try {
    
      
      
      lightbox.option({
        'wrapAround': true,
        'albumLabel': '%1 / total %2 '
      });
      
      
      function fadeAnime(){
      // flipLeft
      $('.editions_list li').each(function(){ 
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight){
            $(this).addClass('flipLeft');
        }else{
            $(this).removeClass('flipLeft');
        }
      });
      }
      
      
      $(window).scroll(function (){
      fadeAnime();
      });
      
      
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-022"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-023"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-024"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-025"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-026-2"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-026"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-027"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-028"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-029"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-030"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-031"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-032"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-033-1"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-033"] && !Shopify.designMode) return;
  try {
               
  lightbox.option({
    'wrapAround': true,
    'albumLabel': '%1 / total %2 '
});
      
      
function fadeAnime(){
  // flipLeft
  $('.editions_list li').each(function(){ 
  var elemPos = $(this).offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  if (scroll >= elemPos - windowHeight){
    $(this).addClass('flipLeft');
    }else{
    $(this).removeClass('flipLeft');
    }
  });
};
      
$(window).scroll(function (){
  fadeAnime();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-15"] && !Shopify.designMode) return;
  try {
    
      
      
      lightbox.option({
        'wrapAround': true,
        'albumLabel': '%1 / total %2 '
      });
      
      
      function fadeAnime(){
      // flipLeft
      $('.editions_list li').each(function(){ 
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight){
            $(this).addClass('flipLeft');
        }else{
            $(this).removeClass('flipLeft');
        }
      });
      }
      
      
      $(window).scroll(function (){
      fadeAnime();
      });
      
      
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-16"] && !Shopify.designMode) return;
  try {
    
      
      
      lightbox.option({
        'wrapAround': true,
        'albumLabel': '%1 / total %2 '
      });
      
      
      function fadeAnime(){
      // flipLeft
      $('.editions_list li').each(function(){ 
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight){
            $(this).addClass('flipLeft');
        }else{
            $(this).removeClass('flipLeft');
        }
      });
      }
      
      
      $(window).scroll(function (){
      fadeAnime();
      });
      
      
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-17"] && !Shopify.designMode) return;
  try {
    
      
      
      lightbox.option({
        'wrapAround': true,
        'albumLabel': '%1 / total %2 '
      });
      
      
      function fadeAnime(){
      // flipLeft
      $('.editions_list li').each(function(){ 
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight){
            $(this).addClass('flipLeft');
        }else{
            $(this).removeClass('flipLeft');
        }
      });
      }
      
      
      $(window).scroll(function (){
      fadeAnime();
      });
      
      
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-18"] && !Shopify.designMode) return;
  try {
    
      
      
      lightbox.option({
        'wrapAround': true,
        'albumLabel': '%1 / total %2 '
      });
      
      
      function fadeAnime(){
      // flipLeft
      $('.editions_list li').each(function(){ 
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight){
            $(this).addClass('flipLeft');
        }else{
            $(this).removeClass('flipLeft');
        }
      });
      }
      
      
      $(window).scroll(function (){
      fadeAnime();
      });
      
      
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-editions-19"] && !Shopify.designMode) return;
  try {
    
      
      
      lightbox.option({
        'wrapAround': true,
        'albumLabel': '%1 / total %2 '
      });
      
      
      function fadeAnime(){
      // flipLeft
      $('.editions_list li').each(function(){ 
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight){
            $(this).addClass('flipLeft');
        }else{
            $(this).removeClass('flipLeft');
        }
      });
      }
      
      
      $(window).scroll(function (){
      fadeAnime();
      });
      
      
      
  } catch(e) { console.error(e); }
})();
})();
